export const ACTION_PREFIX_CHOICE = 'choice'